<div class="fs-2 with-close" mat-dialog-title>
    Modification des caractéristiques
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div class="card-text row">
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>DPE</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.energy_rate">
                    <mat-option value="">NC</mat-option>
                    <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="D">D</mat-option>
                    <mat-option value="E">E</mat-option>
                    <mat-option value="F">F</mat-option>
                    <mat-option value="G">G</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Valeur DPE</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.energy_rate_value">
            </mat-form-field>
        </div>
        <div class="col-md-6">
            <mat-form-field>
                <mat-label>GES</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="favorite.ges">
                    <mat-option value="">NC</mat-option>
                    <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="D">D</mat-option>
                    <mat-option value="E">E</mat-option>
                    <mat-option value="F">F</mat-option>
                    <mat-option value="G">G</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-6">
            <mat-form-field>
                <mat-label>Valeur GES</mat-label>
                <input type="number" step="1" matInput [(ngModel)]="favorite.ges_value">
            </mat-form-field>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline">
        Annuler
    </button>
    <button type="button" (click)="onYesClick()"  class="btn btn-primary">
        Valider
    </button>
</div>


